// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"126f2b0f","498":"6e664c7f","703":"d20f46ec"}[chunkId] + ".chunk.js";
};